import wcs from '@/scripts/libs/wcs'
import { WcsManifest } from '@/scripts/libs/wcs/types/manifest'
import axios from 'axios'
import makeDebug from 'debug'

const debug = makeDebug('wcs-images')

export class WcsImages {
  private manifest: WcsManifest = {} as WcsManifest
  private partNumber = ''

  async getManifest(partNumber: string) {
    if (this.partNumber === partNumber) {
      return this.manifest
    }
    this.partNumber = partNumber
    await this.fetchAndInitializeManifest()

    return this.manifest
  }

  private fetchAndInitializeManifest = async () => {
    const endpoint = wcs.getEndPoint('imagesPDP')
    const response = await axios.get<WcsManifest>(endpoint.replace('$partNumber', this.partNumber))
    this.manifest = response.data

    debug('Fetching manifest', response.data)
  }

  public static generateModule() {
    if (window.WcsImages) {
      return window.WcsImages
    }

    return new WcsImages()
  }
}

window.WcsImages = WcsImages.generateModule()

export default window.WcsImages
